module.exports = __webpack_public_path__ + "templates.destination-section.tcat-seven-eleven-00e6800b.html";